import React, { useState, useEffect, useRef } from 'react'
import {
	Flexgrid,
	FlexgridItem,
	RadioButton,
	TextInput,
	Form,
} from '@wf-wfria/pioneer-core'

export function CustomerContractNumber({
	focusedElement,
	formatMessage,
	customerNumber,
	contractNumber,
	customerOrContract,
	onChange,
	onFocusFactory,
	onSelectCustomerOrContract,
	onTextInputValidator,
}) {
	const [key, setKey] = useState(Date.now())
	const formRef = useRef()
	useEffect(() => {
		if (
			focusedElement !== 'customerNumber' &&
			focusedElement !== 'contractNumber' &&
			focusedElement !== 'userEmail' &&
			focusedElement !== 'existingUserEmail' &&
			focusedElement !== 'invoiceNumber' &&
			focusedElement !== 'serialNumber'
		) {
			if (formRef.current?.resetField) {
				formRef.current.resetField('customerNumber')
			}
			if (formRef.current?.resetField) {
				formRef.current.resetField('contractNumber')
			}

			const newKey = Date.now()
			setKey(newKey)
		}
	}, [focusedElement, setKey])

	const contractValue = contractNumber.value
	const customerValue = customerNumber.value
	const customerOrContractInputDisabled = !customerOrContract

	const isSelectedCustomer = customerOrContract === 'customer'
	const isSelectedContract = customerOrContract === 'contract'
	const valueMissing = formatMessage({ id: 'required-field.empty.error.label' })

	function getCustomerOrContract(customerOrContract) {
		if (customerOrContract === 'customer') {
			return 'customerNumber'
		}
		return 'contractNumber'
	}

	function invokeOnSelectCustomerOrContract({ value }) {
		onSelectCustomerOrContract(value)
	}

	const isArialLabelSelected = isSelectedCustomer
		? `${formatMessage({
				id: 'wca-form.new-user-registration.customer-number.label',
			})}`
		: `${formatMessage({
				id: 'wca-form.new-user-registration.contract-number.label',
			})}`
	let labelToDisplay = ''

	if (!customerOrContractInputDisabled) {
		labelToDisplay = isSelectedCustomer
			? `${formatMessage({
					id: 'wca-form.new-user-registration.customer-number.label',
				})}`
			: `${formatMessage({
					id: 'wca-form.new-user-registration.contract-number.label',
				})}`
	}

	return (
		<Form action="#" ref={formRef}>
			<Flexgrid direction="row" alignVertical="center" columnGap={2}>
				<FlexgridItem span={12}>
					<label htmlFor={getCustomerOrContract(customerOrContract)}>
						{formatMessage({
							id: 'wca-form.new-user-registration.customer-and-contract-number.label',
						})}
					</label>
				</FlexgridItem>
				<FlexgridItem span={{ xxs: 4, sm: 4 }} style={{ marginTop: '16px' }}>
					<RadioButton
						label={formatMessage({
							id: 'wca-form.new-user-registration.customer.label',
						})}
						role="radio"
						value={'customer'}
						name="customer/contract"
						onValueChange={invokeOnSelectCustomerOrContract}
						checked={isSelectedCustomer}
					/>
					<RadioButton
						label={formatMessage({
							id: 'wca-form.new-user-registration.contract.label',
						})}
						role="radio"
						name="customer/contract"
						value={'contract'}
						onValueChange={invokeOnSelectCustomerOrContract}
						checked={isSelectedContract}
					/>
				</FlexgridItem>
				{customerOrContract !== 'contract' && (
					<FlexgridItem span={{ xxs: 8, sm: 8 }}>
						<TextInput
							key={key}
							aria-label={isArialLabelSelected}
							label={labelToDisplay}
							aria-required={true}
							required={true}
							disabled={customerOrContractInputDisabled}
							id={'customerNumber'}
							name={'customerNumber'}
							type="text"
							size="25"
							value={customerValue}
							onValueChange={onChange}
							onFocus={onFocusFactory('WcaRegister')}
							customValidators={[
								(value) =>
									onTextInputValidator(
										getCustomerOrContract('customer'),
										value,
									),
							]}
							nativeValidationMessages={{
								valueMissing,
							}}
						/>
					</FlexgridItem>
				)}
				{customerOrContract === 'contract' && (
					<FlexgridItem span={{ xxs: 8, sm: 8 }}>
						<TextInput
							key={key}
							aria-label={isArialLabelSelected}
							label={labelToDisplay}
							aria-required={true}
							required={true}
							disabled={customerOrContractInputDisabled}
							id={'contractNumber'}
							name={'contractNumber'}
							type="text"
							size="25"
							value={contractValue}
							onValueChange={onChange}
							onFocus={onFocusFactory('WcaRegister')}
							customValidators={[
								(value) =>
									onTextInputValidator(
										getCustomerOrContract('contract'),
										value,
									),
							]}
							nativeValidationMessages={{
								valueMissing,
							}}
						/>
					</FlexgridItem>
				)}
			</Flexgrid>
		</Form>
	)
}
